export default __webpack_public_path__ + "static/media/qt-icon.17f65b3f.webp";